import { StyledSVGButton } from '@/styles/GlobalStyles';
import SvgImage from '@/components/Module/SvgImage';
import React from 'react';

type P = {
  onOpen: () => void;
  open: boolean;
};

const ArrowButton = ({ onOpen, open }: P) => {
  return (
    <StyledSVGButton onClick={onOpen}>
      <SvgImage
        name={'arrowDown'}
        style={{
          transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.3s ease-in-out', // ✅ 부드러운 회전 효과
        }}
      />
    </StyledSVGButton>
  );
};
export default ArrowButton;
